import { render } from "./editLayerProductionProcessModal.vue?vue&type=template&id=c2a20a82&ts=true"
import script from "./editLayerProductionProcessModal.vue?vue&type=script&lang=ts"
export * from "./editLayerProductionProcessModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__